(() => {
  const observed = new WeakSet();
  const skip = 'script,style,template,noscript,svg,button,input,select,textarea,form,[role="button"],a.button,a.btn,[aria-hidden="true"],.fa,.fas,.fab,[class*="icon-"]';
  const normalize = (root) => {
    const snapshots = [root, ...root.querySelectorAll('*')].filter((element) => {
      return !element.hasAttribute('data-rf-type-weight') && element.textContent.trim() && !element.closest(skip);
    }).map((element) => {
      const style = getComputedStyle(element);
      const heading = element.closest('h1,h2,h3,h4,h5,h6,summary');
      const bold = element.closest('strong,b,[data-rf-type-weight="400"]');
      const italic = element.closest('em,i,[data-rf-type-italic="true"]');
      return {
        element,
        weight: heading || bold || parseFloat(style.fontWeight) >= 500 ? '400' : '300',
        italic: italic || /italic|oblique/.test(style.fontStyle) ? 'true' : 'false'
      };
    });
    snapshots.forEach(({ element, weight, italic }) => {
      element.style.removeProperty('font-family');
      element.style.removeProperty('font-weight');
      element.style.removeProperty('font-style');
      element.dataset.rfTypeWeight = weight;
      element.dataset.rfTypeItalic = italic;
    });
    root.dataset.rfTypeReady = 'true';
  };
  const init = (scope) => {
    const roots = [...scope.querySelectorAll('[data-rf-product-description]')];
    if (scope.matches && scope.matches('[data-rf-product-description]')) roots.unshift(scope);
    roots.forEach((root) => {
      normalize(root);
      if (observed.has(root)) return;
      observed.add(root);
      new MutationObserver(() => normalize(root)).observe(root, { childList: true, subtree: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
